@let _copy = copy();

<ng-template #body>
  <mat-icon class="error-state-icon" aria-hidden="true">{{ _copy.icon }}</mat-icon>

  <div class="error-state-text">
    <p class="error-state-title" [class.mat-title-medium]="variant() === 'inline'" [class.mat-headline-small]="variant() === 'page'">
      {{ _copy.title }}
    </p>
    <p class="error-state-message mat-body-medium">{{ _copy.message }}</p>
    @let _seconds = secondsUntilRetry();
    @if (_seconds !== null) {
      <p class="error-state-countdown mat-body-small">
        @if (_seconds > 0) {
          Nächster automatischer Versuch in {{ _seconds }} Sekunden
        } @else {
          Neuer Versuch läuft …
        }
      </p>
    }

    <div class="error-state-actions">
      @if (_copy.retryLabel; as retryLabel) {
        <button type="button" matButton="filled" [disabled]="retrying()" (click)="retry.emit()">
          <mat-icon [libLoading]="retrying()">refresh</mat-icon>
          {{ retryLabel }}
        </button>
      }
      <ng-content select="[actions]"></ng-content>
    </div>
  </div>
</ng-template>

@if (variant() === 'page') {
  <ng-container [ngTemplateOutlet]="body" />
} @else {
  <lib-info-card appearance="neutral">
    <mat-card>
      <mat-card-content class="info-card-content">
        <ng-container [ngTemplateOutlet]="body" />
      </mat-card-content>
    </mat-card>
  </lib-info-card>
}
